export const LEADERS = [
    { name: 'Alex', pos: 'VP of Growth', link: 'https://www.linkedin.com/in/alexkwamin/' },
    { name: 'Tooraj', pos: 'CEO, VP of Tech', link: 'https://www.linkedin.com/in/toorajhelmi/' },
    { name: 'Paulina', pos: 'VP of Experience', link: 'https://www.linkedin.com/in/dpaulinav/' }
];
export const ORDERED_LEADERS = [2, 0, 1];
export const DUP_LEAD = [...Array(3 * 20)].map((_, i) => LEADERS[i % 3]);
export const BASE_HEIGHT = 10;
export const BASE_HEIGHT_VH = `${BASE_HEIGHT}vw`;
export const BASE_MAX_HEIGHT = 80;
export const INFO_HEIGHT = 30;
export const INFO_MAX_HEIGHT = 300;
export const INFO_HEIGHT_VH = `${INFO_HEIGHT}vw`;
export const FULL_HEIGHT = INFO_HEIGHT;
export const FULL_MAX_HEIGHT = INFO_MAX_HEIGHT + 1.5 * BASE_MAX_HEIGHT;
export const FULL_HEIGHT_VH = `${FULL_HEIGHT}vw`;
export const REMAINING_KEY = [2, 3, 4];
export const ABS_MARGIN_TOP = BASE_HEIGHT * (REMAINING_KEY[0] + 1);

export const MOBILE_HEIGHT_COEF = 3;
export const INFO_WIDTH = INFO_HEIGHT * 2;
export const INFO_MAX_WIDTH = 2 * INFO_MAX_HEIGHT + 40;

export const TITLE_WIDTH_RATIO = 30;

export const LEADERS_INFO = [...Array(3 * 20)].map((_, idx) => ({
    ...LEADERS[idx % 3]
}));

export function clacInfoTop(idx: number) {
    return FULL_MAX_HEIGHT * idx + BASE_MAX_HEIGHT * 1.2 + (FULL_MAX_HEIGHT - INFO_MAX_HEIGHT) / 2;
}

export function clacFullHeight(fullHeight: any, isXSmall: boolean, isSmallScr: boolean) {
    if (isSmallScr && !isXSmall) {
        return fullHeight.interpolate(
            (o: number) => `${BASE_HEIGHT + o * (FULL_HEIGHT + 2 * BASE_HEIGHT)}vw`
        );
    } else if (isXSmall) {
        return fullHeight.interpolate(
            (o: number) => `${BASE_HEIGHT + MOBILE_HEIGHT_COEF * o * FULL_HEIGHT}vmax`
        );
    } else {
        return fullHeight.interpolate(
            (o: number) => BASE_MAX_HEIGHT + o * (FULL_MAX_HEIGHT - BASE_MAX_HEIGHT)
        );
    }
}

export function clacAbsLabelTop(
    idx: number,
    bottomPosAbs: any,
    topPosAbs: any,
    isSmallScr: boolean
) {
    if (isSmallScr) {
        if (idx > REMAINING_KEY[1])
            return bottomPosAbs.interpolate((o: number) => `${o * (idx + 1) - BASE_HEIGHT}vmax`);
        return topPosAbs.interpolate((o: number) => `${o * (idx + 1) - BASE_HEIGHT}vmax`);
    } else {
        if (idx > REMAINING_KEY[1])
            return bottomPosAbs.interpolate((o: number) => o * (idx + 1) * 8 - BASE_MAX_HEIGHT);
        return topPosAbs.interpolate((o: number) => o * (idx + 1) * 8 - BASE_MAX_HEIGHT);
    }
}

export function clacAbsLabelMarginTop(idx: number, isSmallScr: boolean) {
    if (isSmallScr) {
        if (idx === REMAINING_KEY[0]) return `${BASE_HEIGHT * idx}vmax`;
        return 0;
    } else {
        if (idx === REMAINING_KEY[0]) return BASE_MAX_HEIGHT * idx;
        return 0;
    }
}

export function clacInfoLeft(left: any, isSmallScr: boolean, isXSmall: boolean) {
    if (isSmallScr || isXSmall) {
        return left.interpolate((o: number) => `translate(${o * INFO_MAX_WIDTH}vw)`);
    } else {
        return left.interpolate((o: number) => `translate(${o * INFO_MAX_WIDTH}px)`);
    }
}

export function clacTitleTranslate(titleTransform: any, isSmallScr: boolean) {
    if (isSmallScr) {
        return titleTransform.interpolate((o: number) => `translateY(${3 + o * 10}vw)`);
    } else {
        return titleTransform.interpolate((o: number) => `translateY(${3 + o * 10}vw)`);
    }
}
